export const LIGHTNESS_THRESHOLD = 65;
export const DEFAULT_GRADIENT_BASE_COLOR = '#D2D2D2';
export const DEFAULT_ASPECT_RATIO = '56.25%';
export const DEFAULT_Z_INDEX = 1;
export const DEFAULT_MIX_BLEND_MODE = 'normal';
export const DEFAULT_OPACITY = 1;
export const DEFAULT_MAIN_COLOR = '#FFFFFF';
export const DEFAULT_CLASS_NAME = 'mock-up-background-layer';
export const DEFAULT_VARIATION_BACKGROUND = 'transparent';
export const MOCK_UP_LAYERS = {
    BACKGROUND_LAYER: 'background',
    GRADIENT_LAYER: 'gradient',
    IMAGE_LAYER: 'image',
    VARIATION_LAYER: 'variation',
};

export const GRADIENT_TYPES = {
    LINEAR: 'linear',
    RADIAL: 'radial',
};

export const CLOUDINARY_PREFIX =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_auto/v1/attachments/generic_asset/asset/';
